module.exports = __webpack_public_path__ + "img/stock7.b129336f.png";